export function normalizePhone(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';

  const normalized = digits.startsWith('8') ? `7${digits.slice(1)}` : digits;

  if (normalized.length === 11 && normalized.startsWith('7')) {
    return `+${normalized}`;
  }

  if (normalized.length === 11) {
    return `+${normalized}`;
  }

  return '';
}

export function formatPhone(value?: string | null): string {
  if (value == null || value === '') {
    return '';
  }

  if (value.length === 12 && value.startsWith('+') && value[1] === '7') {
    let i = 0;
    const normalized = normalizePhone(value).replace('+', '');
    // eslint-disable-next-line no-plusplus
    return '+# (###) ###-##-##'.replaceAll('#', () => String(normalized[i++]));
  }

  return value;
}
